import { map, reduce } from 'ramda'

import { Report, ReportRow } from '@driftt/api-types'

import { LineGraphResponse } from '../types'

const ensureNoNan = (value: any): number => (value === 'NaN' ? 0 : value)

export const parseCallsMade = (response) => response

export const parseTotalCallsMade = (response: Report) => {
  return { calls: response.data.rows[0].metrics[0] }
}

export const parseCumulativeLine = (response: Report): LineGraphResponse => {
  return reduce<ReportRow, any>(
    (acc: any[], row: ReportRow) => {
      const prevVal = acc.length > 0 ? acc[acc.length - 1][1] : 0
      return [
        ...acc,
        [row.dimensions[0], ensureNoNan(row.metrics[0] + prevVal)],
      ]
    },
    [],
    response.data.rows
  )
}

export const parseCallsMadeByRep = (response: Report) =>
  map(
    (row) => ({
      user: row.dimensions[0],
      value: ensureNoNan(row.metrics[0]),
    }),
    response.data.rows
  )
